<div class="content-wrapper">


    <div class="row">
        <div class="col-md-12 grid-margin">
            <div class="card-dashboard">
                <div class="card-dashboard-body">
    

                      <div class="container">
                        <div class="row cards-d">
                          <!-- <div class="col-md-3">
                            <div class="card card-1" routerLink="/v/admin/roommanagement">
                              <div class="image-card">
                                <img src="/assets/images/Management.png" alt="image-management">
                            </div> 
                              <h3>Room Management</h3>
                              <p></p>
                            </div>
                          </div> -->

                          <div class="col-md-3">
                            <div class="card card-1" routerLink="/v/admin/roommanagement" style="position: relative;">
                              <div class="icon-view pr-2 pt-1" style="position: absolute; top: 0; right: 0;" routerLink="/v/admin/roombookingreport">
                                <!-- <i class="fas fa-eye" title="Click to View Report"></i>  -->
                                <i class="fa-solid fa-file-invoice" title="Click to View Report"></i>
                              </div>
                              <div class="image-card">
                                <img src="/assets/images/Management.png" alt="image-management">
                            </div> 
                              <h3>Room Management</h3>
                              <p></p>
                            </div>
                          </div>


                          <!-- <div class="col-md-3">
                            <div class="card card-2" routerLink="/v/admin/donationmanagement">
                              <div class="image-card">
                                <img src="/assets/images/donate.png" alt="image-management">
                            </div> 
                              <h3> Donation Management</h3>
                              <p></p>
                            </div>
                          </div> -->


                          <div class="col-md-3">
                            <div class="card card-2" routerLink="/v/admin/donationmanagement" style="position: relative;">
                              <!-- Your icon code here -->
                              <div class="icon-view pr-2 pt-1" style="position: absolute; top: 0; right: 0;" routerLink="/v/admin/donationreport">
                                <i class="fa-solid fa-file-invoice" title="Click to View Report"></i>
                              </div>
                          
                              <div class="image-card">
                                <img src="/assets/images/donate.png" alt="image-management">
                              </div>
                              <h3> Donation Management</h3>
                              <p></p>
                            </div>
                          </div>
                          
                          
                          
                        
                          <!-- <div class="col-md-3">
                            <div class="card card-2" routerLink="/v/admin/packagebookingmanagement">
                              <div class="image-card">
                                <img src="/assets/images/pooja.png" alt="image-management">
                            </div> 
                              <h3> Poojan Booking Management</h3>
                              <p></p>
                            </div>
                          </div> -->


                          <div class="col-md-3">
                            <div class="card card-2" routerLink="/v/admin/packagebookingmanagement" style="position: relative;">
                              <div class="icon-view pr-2 pt-1" style="position: absolute; top: 0; right: 0;" routerLink="/v/admin/packagebookingreport">
                                <i class="fa-solid fa-file-invoice" title="Click to View Report"></i>
                              </div>
                              <div class="image-card">
                                <img src="/assets/images/pooja.png" alt="image-management">
                            </div> 
                              <h3> Poojan Booking Management</h3>
                              <p></p>
                            </div>
                          </div>

                          <div class="col-md-3">
                            <div class="card card-2" routerLink="/v/admin/vehiclepassmanagement" style="position: relative;">
                              <div class="icon-view pr-2 pt-1" style="position: absolute; top: 0; right: 0;" routerLink="/v/admin/vehiclepassreport">
                                <i class="fa-solid fa-file-invoice" title="Click to View Report"></i>
                              </div>
                              <div class="image-card">
                                <img src="/assets/images/vehiclepass.png" alt="image-management">
                            </div> 
                              <h3> Vehicle Pass Management</h3>
                              <p></p>
                            </div>
                          </div>


                          <div class="col-md-3">
                            <div class="card card-4" routerLink="/v/admin/websitebanner">
                              <div class="image-card">
                                <img src="/assets/images/bannericons.png" alt="image-websitebanner">
                            </div>
                              <h3> Website Banner</h3>
                              <p></p>
                            </div>
                          </div>


                          <!-- <div class="col-md-3">
                            <div class="card card-2" routerLink="/v/admin/roombookingreport">
                              <div class="image-card">
                                <img src="/assets/images/report-image.jpg" alt="image-manager">
                            </div>
                              <h3>Room Booking Report</h3>
                              <p></p>
                            </div>
                          </div> -->

                            
                          <!-- <div class="col-md-3">
                            <div class="card card-2" routerLink="/v/admin/donationreport">
                              <div class="image-card">
                                <img src="/assets/images/donation.png" alt="image-report">
                            </div>
                              <h3>Online Donation Report</h3>
                              <p></p>
                            </div>
                          </div> -->
                        

                        <!-- <div class="col-md-3">
                          <div class="card card-4" routerLink="/v/admin/packagebookingreport">
                            <div class="image-card">
                              <img src="/assets/images/packagebookingreport.png" alt="image-packagereport">
                          </div>
                            <h3>Package Booking Report</h3>
                            <p></p>
                          </div>
                        </div> -->


                        
                    

                        <!-- <div class="col-md-3">
                          <div class="card card-6" routerLink="/v/admin/vehiclepassreport">
                            <div class="image-card">
                              <img src="/assets/images/donation.png"  alt="image-websitebanner">
                          </div>
                            <h3> Vehicle Pass Booking Report</h3>
                            <p></p>
                          </div>
                        </div> -->



                        <div class="col-md-3">
                          <div class="card card-8" routerLink="/v/admin/manage-tender"  >
                            <div class="image-card pr-4">
                              <img src="/assets/images/tender.png"  alt="image-websitebanner">
                          </div>
                            <h3> Website Tenders</h3>
                            <p></p>
                          </div>
                        </div>


                        <div class="col-md-3">
                          <div class="card card-9" routerLink="/v/admin/manage-notification" >
                            <div class="image-card ">
                              <img src="/assets/images/notification.png"  alt="image-websitebanner">
                          </div>
                            <h3> Website Notifications</h3>
                            <p></p>
                          </div>
                        </div>

                        

                        <div class="col-md-3">
                          <div class="card card-9" routerLink="/v/admin/manage-gallery"  >
                            <div class="image-card pr-4">
                              <img src="/assets/images/gallery.png"  alt="image-websitebanner">
                          </div>
                            <h3> Website Gallery</h3>
                            <p></p>
                          </div>
                        </div>

                        <div class="col-md-3">
                          <div class="card card-2" routerLink="/v/admin/prasadmanagement" style="position: relative;">
                            <div class="icon-view pr-2 pt-1" style="position: absolute; top: 0; right: 0;" routerLink="/v/admin/prasadorderreport">
                              <i class="fa-solid fa-file-invoice" title="Click to View Report"></i>
                            </div>
                            <div class="image-card">
                              <i class="fa-solid fa-hands-praying" style="font-size:52px; color:#000;"></i>
                            </div>
                            <h3>Prasad / Souvenir Management</h3>
                            <p></p>
                          </div>
                        </div>
                    
                    <!--<ol class="breadcrumb rv-breadcrumb">
                        <li class="breadcrumb-item"><a class="rv-active" routerLink="/dashboard/home">Home</a></li>
                    </ol>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="d-sm-flex align-items-baseline report-summary-header">
                                <h5 class="font-weight-semibold">Admin Dashboard </h5>
                            </div>
                        </div>
                    </div>
                    <div class="row report-inner-cards-wrapper">
                        <div *ngFor="let item of arr_submenus" class=" col-lg-3 col-md-4 mb-3  ">
                            <a routerLink={{item.routelink}} class="rv-report-link">
                                <div class="rv-bc-2 report-inner-card rv-pull-up">
                                    <div class="inner-card-text p-2">
                                        <h4>{{item.menuname}}</h4>
                                    </div>

                                    <div class="inner-card-icon rv-bg-2">
                                        <i class="{{item.css}}"></i>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>-->


                  </div>


                  </div>
                </div>
            </div>
        </div>
    </div>


</div>